import Vue from 'vue'
import { Watch } from 'vue-property-decorator'

import Component from 'vue-class-component'
import JhiNavbar from '@/core/jhi-navbar/jhi-navbar.vue'
import { AlertVariant } from '@/shared/enums/alert'
import { LS_KEY_SELECTED } from '@/shared/config/store/marketplace-store'
import { Route } from 'vue-router'
import { marketPlaceRoutes } from '@/router'
import { trackPageViewedEvent, trackLoginEvent } from '@/shared/tracking'

@Component({
  components: {
    'jhi-navbar': JhiNavbar,
  },
})
export default class App extends Vue {
  @Watch('$route')
  onRouteChange (to: Route, from: Route): void {
    this.resetAlert()
    this.trackOnRouteChanged(to)
  }
  public alertOpen = false
  public alertVariant: AlertVariant = AlertVariant.INFO
  public alertText = ''
  created (): void {
    this.$root.$on('mc-show-alert', ({ text, variant }: {text: string; variant?: AlertVariant; timeout?: number}) => {
      this.alertOpen = true
      this.alertText = text
      if (variant) this.alertVariant = variant
      if (variant === AlertVariant.DANGER) {
        this.alertText.concat('\nIf the problem persists please, contact #messaging-general in slack.')
      }
    })
    this.$root.$on('mc-hide-alert', () => {
      this.resetAlert()
    })
    this.$root.$on('new-selected-marketplace', ({ marketplace }: { marketplace: string }) => {
      trackPageViewedEvent({ marketplace, track: this.$track })
    })
    this.$track({ type: 'View', name: 'View Messaging Management Console' })
  }

  updated () {
    // We need information in state which are ready in updated lifecycle hook with load event to only be executed once as intended
    window.addEventListener('load', () => {
      // each load means a new login for now, so we can send login event via Pulse
      const intervalId = setInterval(() => {
        const userEmail = this.$store.getters.account.login

        if (userEmail) {
          clearInterval(intervalId)
          const selectedMarketplace = window.localStorage.getItem(LS_KEY_SELECTED) || ''
          trackLoginEvent({ marketplace: selectedMarketplace, track: this.$track, email: this.$store.getters.account.login })
        }
      }, 500)
    })
  }

  public get alertTimeout (): number | null {
    return this.alertVariant === AlertVariant.DANGER ? null : 2000
  }

  resetAlert (): void {
    this.alertOpen = false
    this.alertVariant = AlertVariant.INFO
    this.alertText = ''
  }

  private trackOnRouteChanged (to: Route) {
    const isMarketplaceRoute = marketPlaceRoutes.find(route => route.name === to.name)

    if (isMarketplaceRoute) {
      const selectedMarketplace = window.localStorage.getItem(LS_KEY_SELECTED) || ''
      trackPageViewedEvent({ marketplace: selectedMarketplace, track: this.$track })
    }
  }
}
